/**
 * Created by mathieudeumie on 04/08/2014.
 */

angular.module('FlexyBeautyApp.services').factory('CustomerStatView', ["CustomerData",
    function (CustomerData) {
        var CustomerStatView = function (booking, sale) {
            if (booking) {
                if (booking.customer) {
                    this.id = booking.customer.id;
                    this.ca = 0;
                    this.averagePrice = 0;

                    this.equivalentCustomer = booking.customer;
                    this.globalCa = 0;
                    this.globalAveragePrice = 0;

                    this.firstName = booking.customer.firstName;
                    this.lastName = booking.customer.lastName;
                    if (booking.customer.bookings && booking.customer.bookings.length != 0)
                        this.idOfFirstBookingDay = booking.customer.bookings[0].day.id;
                    else
                        this.idOfFirstBookingDay = -1;

                } else {
                    this.id = -1;
                    this.ca = 0;
                    this.averagePrice = 0;

                    this.equivalentCustomer = null;
                    this.globalCa = 0;
                    this.globalAveragePrice = 0;

                    this.firstName = "Client de passage";
                    this.lastName = "";
                    this.idOfFirstBookingDay = -1;
                    this.listOfBookings = [];
                    this.listOfSales = [];
                }
                if (booking.bookingServices.length > 0) {
                    this.listOfBookings = [booking];
                    this.setCa();
                    this.setAveragePrice();
                    this.setGlobalValues();
                }
            } else if (sale) {
                this.listOfSales = [];
                if (sale.customer) {
                    this.id = sale.customer.id;
                    this.ca = 0;
                    this.globalNbSales = 0;
                    this.averagePrice = 0;

                    this.equivalentCustomer = sale.customer;
                    this.globalCa = 0;
                    this.globalAveragePrice = 0;

                    this.firstName = sale.customer.firstName;
                    this.lastName = sale.customer.lastName;
                    this.idOfFirstSaleDay = sale.customer.sales[0].day.id;
                } else {
                    this.id = -1;
                    this.ca = 0;
                    this.averagePrice = 0;

                    this.equivalentCustomer = null;
                    this.globalCa = 0;
                    this.globalAveragePrice = 0;

                    this.firstName = "Client de passage";
                    this.lastName = "";
                    this.idOfFirstSaleDay = -1;
                    this.listOfBookings = [];
                }
                if (sale.saleServices.length > 0 || sale.saleProducts.length > 0) {
                    this.listOfSales = [sale];
                    this.setCa();
                    this.setAveragePrice();
                    this.setGlobalValues();
                }

            } else {
                this.id = -10;
                this.ca = 0;
                this.averagePrice = 0;

                this.equivalentCustomer = null;
                this.globalCa = 0;
                this.globalAveragePrice = 0;

                this.firstName = "";
                this.lastName = "";
                this.idOfFirstBookingDay = -10;
                this.listOfBookings = [];
                this.listOfSales = [];
            }
        };

        CustomerStatView.prototype.getModel = function () {
            if (this.id != -1)
                return CustomerData.getById(this.id);
            return null;
        };
        CustomerStatView.prototype.addBooking = function (booking) {
            if (booking && this.listOfBookings) {
                this.listOfBookings.push(booking);
                this.setCa();
                this.setAveragePrice();
            }
        };
        CustomerStatView.prototype.addSale = function (sale) {
            if (sale && this.listOfSales) {
                this.listOfSales.push(sale);
                this.setCa();
                this.setAveragePrice();
            }
        };
        CustomerStatView.prototype.getCa = function () {
            return this.ca;
        };
        CustomerStatView.prototype.setCa = function () {
            this.ca = 0;
            if (this.listOfBookings)
                for (var i = 0; i < this.listOfBookings.length; i++)
                    this.ca += this.listOfBookings[i].price;
            if (this.listOfSales)
                for (var i = 0; i < this.listOfSales.length; i++)
                    this.ca += this.listOfSales[i].price;

        };
        CustomerStatView.prototype.isOld = function (period) // array of day
        {
            if (this.id === -1) // Client de passage is new by default
                return false;
            if (period[0])
                return (this.idOfFirstSaleDay < period[0].id);
            else
                return false; // case of opening month of institute : customer is new
        };
        CustomerStatView.prototype.getName = function () {
            return this.firstName + " " + this.lastName;
        };
        CustomerStatView.prototype.getAveragePrice = function () {
            return this.averagePrice;
        };
        CustomerStatView.prototype.setAveragePrice = function () {
            if (this.listOfBookings && this.listOfBookings.length != 0)
                this.averagePrice = Math.round(this.ca / this.listOfBookings.length * 100) / 100;
            else if (this.listOfSales && this.listOfSales.length != 0)
                this.averagePrice = Math.round(this.ca / this.listOfSales.length * 100) / 100;

        };
        CustomerStatView.prototype.getGlobalCa = function () {
            return this.globalCa;
        };
        CustomerStatView.prototype.getGlobalNbBookings = function () {
            return this.equivalentCustomer.bookings.length;
        };
        CustomerStatView.prototype.getGlobalAveragePrice = function () {
            return this.globalAveragePrice;
        };
        CustomerStatView.prototype.setGlobalValues = function () {
            this.globalCa = 0;
            if (this.listOfSales && this.equivalentCustomer) {
                this.globalNbSales = 0;
                for (var i = 0; i < this.equivalentCustomer.sales.length; i++) {
                    var sale = this.equivalentCustomer.sales[i];
                    if (sale.status == "sold") {
                        this.globalCa += sale.price;
                        this.globalNbSales++;
                    }
                }
                this.globalAveragePrice = Math.round(this.globalCa / this.globalNbSales * 100) / 100;
            } else if (this.listOfBookings && this.equivalentCustomer) {
                for (var i = 0; i < this.equivalentCustomer.bookings.length; i++) {
                    var booking = this.equivalentCustomer.bookings[i];
                    this.globalCa += booking.price;
                }
                this.globalAveragePrice = Math.round(this.globalCa / this.getGlobalNbBookings() * 100) / 100;
            }
        };

        return CustomerStatView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/CustomerStatView.js